import { A2kMarquee } from "./A2kMarquee.js";
window.customElements.define("a2k-marquee", A2kMarquee);
